// removed by extract-text-webpack-plugin
module.exports = {"mainIndex":"_2vwx-TL4uCxNZeOqAPsaHt","img":"_10puSc6szNEeDEJF3Zyo2-","index":"_2QsUAr4tRd07xQiwhg6ib2","is-mobile":"_2Jf3nS0xD0hBcp4CCsE8-m"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Main/index.css
// module id = 140
// module chunks = 0